export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 border-t border-line bg-surface-warm">
      <div className="mx-auto flex max-w-container flex-col gap-8 px-6 py-12 md:flex-row md:items-start md:justify-between">
        <div>
          <p className="mb-1 font-display text-h3 uppercase text-primary">Tanzraum Köln</p>
          <p className="text-body-sm text-ink-soft">
            Drei Studios in Köln · Zentrum · Nippes · Am&nbsp;Dom
          </p>
          <p className="mt-3 text-body-sm text-ink-muted">
            © {year} Tanzschule Tanzraum. Tanz ist für alle.
          </p>
          <p className="mt-1 text-caption text-ink-muted">
            Umsetzung:{" "}
            <a
              href="https://antonioblago.com"
              target="_blank"
              rel="noopener"
              className="underline-offset-2 hover:text-primary hover:underline"
            >
              Antonio Blago
            </a>
          </p>
        </div>

        <nav
          aria-label="Footer-Navigation"
          className="grid grid-cols-2 gap-x-10 gap-y-2 text-body-sm text-ink-soft md:grid-cols-3"
        >
          <a href="/impressum" className="hover:text-primary">
            Impressum
          </a>
          <a href="/datenschutz" className="hover:text-primary">
            Datenschutz
          </a>
          <a href="/agb" className="hover:text-primary">
            AGB
          </a>
          <a href="mailto:info@tanzschule-tanzraum.de" className="hover:text-primary">
            E-Mail
          </a>
          <a
            href="https://www.tanzschule-tanzraum.de"
            target="_blank"
            rel="noreferrer"
            className="hover:text-primary"
          >
            Hauptseite
          </a>
          <a
            href="https://www.tanzschule-tanzraum.de/stundenplan"
            target="_blank"
            rel="noreferrer"
            className="hover:text-primary"
          >
            Stundenplan
          </a>
        </nav>
      </div>
    </footer>
  );
}
